import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18next.use(LanguageDetector).init({
    detection: { 
		order: ['cookie', 'localStorage', 'sessionStorage', 'navigator'],
		caches: ['localStorage', 'cookie'],
		cookieMinutes: 60*24*365,// 1 year
	 },
    interpolation: { escapeValue: false },  // React already does escaping
    fallbackLng: "fr",
	supportedLngs : ['fr', 'en'],
	lowerCaseLng: true,
	//lng:'fr',
	react: { 
		useSuspense: false // <---- prevent a bug on react...
	}
});

ReactDOM.render(
	<React.StrictMode>
		<I18nextProvider i18n={i18next}>
			<App />
		</I18nextProvider>
	</React.StrictMode>,
	document.getElementById('root')
);
